import { convertDate } from './convertDate';

type DocumentItem = {
    documentMetadataName: string;
    productName: string;
    translations: Record<string, string>;
    documentFileNames: Record<string, string>;
    version?: string | number;
    createDates: Record<string, string>;
};

export const adaptDocLibrary = (
    data: DocumentItem[],
    downloadDocument: (documentId: string, fileName: string) => void,
    downloadInProgress: Record<string, boolean>,
    onDelete: (documentId: string, content: string) => void,
    deleteInProgress: Record<string, boolean>,
) => (data || [])
    .map((item) => {
        const {
            documentMetadataName,
            productName,
            translations,
            documentFileNames,
            version,
            createDates,
        } = item;

        return {
            documentMetadataName,
            productName,
            version: version ?? '0',
            documentsFilesNames: {
                names: getDocumentsFilesNames(createDates, documentFileNames),
            },
            documentsCreatedDates: {
                createdDates: getDocumentsCreatedDates(createDates),
            },
            linkDownload: {
                options: getLinkDownloadOptions(translations, createDates),
                productName,
                documentMetadataName,
                documentFileNames,
                onDownload: downloadDocument,
                downloadInProgress,
                onDelete,
                deleteInProgress,
            },
        };
    });

const getCreatedDatesDescending = (createDates: Record<string, string>) => {
    const dates = Object.keys(createDates).map((key) => ({
        language: key, createDate: createDates[key],
    }));

    return dates.sort((a, b) => new Date(b.createDate).getTime() - new Date(a.createDate).getTime());
};

const getLinkDownloadOptions = (translations: Record<string, string>, createDates: Record<string, string>) => {
    const dates = getCreatedDatesDescending(createDates);

    return dates.map((item) => ({
        text: item.language ?? '',
        id: translations[item.language] ?? '',
    }));
};

const getDocumentsFilesNames = (createDates: Record<string, string>, documentFileNames: Record<string, string>) => {
    const dates = getCreatedDatesDescending(createDates);

    return dates.map((item) => ({
        name: documentFileNames[item.language] ?? '',
    }));
};

const getDocumentsCreatedDates = (createDates: Record<string, string>) => {
    const dates = getCreatedDatesDescending(createDates);

    return dates.map((item) => ({
        createdDate: convertDate(item.createDate) ?? '',
    }));
};
